export default __webpack_public_path__ + "static/media/2.89f4c044.jpg";